<div class="app-footer">
	<div class="row">
		
	</div>
	<div class="footer-bottom border-top pt-3 d-flex flex-column flex-sm-row align-items-center">
       
	</div>
</div>